import * as _ from "lodash";
import * as React from "react";

interface IEditorPaneProps{
	show?: boolean;
	width?: number;
	title?: string;
	color?: string;
	onRefresh?(): void;
	onClose?(): void;
}

export class EditorPane extends React.Component<IEditorPaneProps, undefined>
{
	constructor(props, state){
		super(props, state);

		this.handleClose = this.handleClose.bind(this);
		this.handleRefresh = this.handleRefresh.bind(this);
	}

	handleRefresh(){
		if(this.props.onRefresh){
			this.props.onRefresh();
		}
	}

	handleClose(){
		if(this.props.onClose){
			this.props.onClose();
		}
	}


	render(){
		let width = _.isUndefined(this.props.width) ? 650 : this.props.width;
		let style = this.props.show ? {"right": 0, "width": width} : {"right": -width - 10, "width": width};

		let color = _.isUndefined(this.props.color) ? "blue" : this.props.color;

		let showRefresh = !_.isNil(this.props.onRefresh);
		let showClose = !_.isNil(this.props.onClose);

		return (
			<div className="editor-pane" style={style}>
				<div className="ui middle aligned grid">
					<div className={color + " row"}>
						<div className="thirteen wide column">
							<h2>{this.props.title}</h2>
						</div>
						<div className="one wide column right aligned">
							{showRefresh &&
								<button className="ui icon button blue" title="Refresh" onClick={this.handleRefresh}>
									<i className="ui big icon refresh"></i>
								</button>
							}
						</div>
						<div className="two wide column left aligned">
							{showClose &&
								<button className="ui icon button blue" title="Close" onClick={this.handleClose}>
									<i className="ui big icon close"></i>
								</button>
							}
						</div>
					</div>
					<div className="row">
						<div className="sixteen wide column">
							{this.props.children}
						</div>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/common/editor-pane.tsx